import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { TranslateModule } from '@ngx-translate/core';
import { DotsSpinnerComponent } from '@shared/components/dots-spinner/dots-spinner.component';
import { IconComponent } from '@shared/components/icon/icon.component';

@Component({
  imports: [MatButtonModule, MatMenuModule, TranslateModule, DotsSpinnerComponent, IconComponent],
  selector: 'app-finding-card-menu',
  templateUrl: './finding-card-menu.component.html',
})
export class FindingCardMenuComponent {
  public readonly pendingDeletion = input<boolean>(false);
  public readonly busy = input<boolean>(false);
  public readonly deletable = input<boolean>(false);

  public readonly deleteFinding = output<void>();
  public readonly revertFinding = output<void>();
}
